module.exports = __webpack_public_path__ + "img/banner_new.9406f3e9.png";